import http from './http.api';
import filehttp from './http.api';
import axios from 'axios';

const SHAREFILE_TEST_BASE_URL = process.env.REACT_APP_SHAREFILE_BASE_URL || '';

export const uploadProjectFiles = async (file: File, folderId: string): Promise<any> => {
  const url = `${SHAREFILE_TEST_BASE_URL}/api/ShareFile/upload-file-by-folderId?folderId=${folderId}`;

  try {
    const response = await filehttp.post(url, file, {
      headers: {
        'FileName': file.name,
      },
    });

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data || error.message);
    }
    throw new Error('Unknown upload error');
  }
};

export const uploadCARFiles = async (file: File, folderPath: string): Promise<any> => {
  const url = `${SHAREFILE_TEST_BASE_URL}/api/ShareFile/upload-file-by-folderId?folderId=${folderPath}`;

  try {
    const response = await filehttp.post(url, file, {
      headers: {
        'FileName': file.name,
      },
    });

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data || error.message);
    }
    throw new Error('Unknown upload error');
  }
};

export const getFilesByFolderId = async (folderId: string, token?: string): Promise<any> => {
  const url = `${SHAREFILE_TEST_BASE_URL}/api/ShareFile/get-files/${folderId}`;

  try {
    const response = await http.get(url, {
      headers: {
        'accept': '*/*',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data || error.message);
    }
    throw new Error('Unknown fetch error');
  }
};
